module.exports = __webpack_public_path__ + "img/image7-1.f5596241.jpg";